import { productCardTransportConverter } from "../../card-product/desktop/index.js";
export const carouselProductTransportConverter = (carousel)=>{
    const { searcher ={} , config ={} , items =[] , title ='' , subtitle ='' , viewMore ={
        href: ''
    } , isFirstComponent  } = carousel;
    return {
        props: {
            config: {
                literals: {
                    ...config.literals,
                    summary: config.literals?.summaryLabel,
                    moreInfo: config.literals?.infoLabel
                },
                product: config.type ?? undefined
            },
            searcher,
            title: {
                title: title ?? '',
                subTitle: subtitle
            },
            items: items?.map((item)=>productCardTransportConverter(item, carousel.config)),
            link: viewMore,
            isFirstComponent
        }
    };
};
export const tabProductTransportConverter = (tab)=>({
        searcher: tab.data?.searcher,
        title: tab.title ?? '',
        params: tab?.arguments?.map((item)=>({
                key: item.Name,
                value: item.Value
            })),
        items: tab.data?.items?.map((item)=>productCardTransportConverter(item, tab.data?.config)),
        link: tab.data?.viewMore
    });

//# sourceMappingURL=index.js.map